import React, { useEffect, useState } from 'react'
// Make sure the file exists at the correct path and with the correct casing.
// For example, if the file is named 'Meetings01.tsx', update the import as follows:
import Finance01 from './financialsPanels/financialPanels01'
import Finance02 from './financialsPanels/financialPanels02'
import Finance00 from './financialsPanels/financialPanels00'
import Finance03 from './financialsPanels/financialPanels03'

const Sidebar: React.FC = () => {
  const [openTab, setOpenTab] = useState<string | null>('Finance25')
  const [openPanel, setOpenPanel] = useState<string | null>('Finance25')

  const handleTabClick = (tabName: string) => {
    if (tabName === openTab) {
      return
    } else {
      setOpenTab(openTab === tabName ? null : tabName)
      setOpenPanel(tabName)
    }
  }

  const handlePanelClick = (panelName: string) => {
    setOpenPanel(openPanel === panelName ? panelName : panelName)
  }
  useEffect(() => {
    console.log(openPanel)
  }, [])

  return (
    <div className="flex md:flex-row flex-col relative min-h-[25rem] mb-10 gap-10">
      {/* All the tabs and nested tabs are rendered here */}
      <div className="flex-1 2xl:max-w-md max-w-sm w-full h-full bg-green-800 pt-6">
        <ul className="flex flex-col gap-3">
  
          {/* <li className="border-b border-opacity-10 border-black 2xl:pb-5 pb-4 mb-2 cursor-pointer">
            <button
              onClick={() => handleTabClick('Meetings')}
              className={`${
                openTab === 'Meetings' && 'text-yellow'
              } w-full text-left flex items-center justify-between`}
            >
              <h5 className="font-semibold ">2022-23</h5>
              {openTab === 'Meetings' ? <Arrow /> : <Arrow active />}
            </button>
          </li> */}

          <li className="border-b border-opacity-10 border-black 2xl:pb-5 pb-4 mb-2 cursor-pointer">
            <button
              onClick={() => handleTabClick('Finance22')}
              className={`${
                openTab === 'Finance22' && 'text-yellow'
              } w-full text-left flex items-center justify-between`}
            >
              <h5 className="font-semibold ">2022-23</h5>
              {openTab === 'Finance22' ? <Arrow /> : <Arrow active />}
            </button>
          </li>

          <li className="border-b border-opacity-10 border-black 2xl:pb-5 pb-4 mb-2 cursor-pointer">
            <button
              onClick={() => handleTabClick('Finance23')}
              className={`${
                openTab === 'Finance23' && 'text-yellow'
              } w-full text-left flex items-center justify-between`}
            >
              <h5 className="font-semibold ">2023-24</h5>
              {openTab === 'Finance23' ? <Arrow /> : <Arrow active />}
            </button>
          </li>

          <li className="border-b border-opacity-10 border-black 2xl:pb-5 pb-4 mb-2 cursor-pointer">
            <button
              onClick={() => handleTabClick('Finance24')}
              className={`${
                openTab === 'Finance24' && 'text-yellow'
              } w-full text-left flex items-center justify-between`}
            >
              <h5 className="font-semibold ">2024-25</h5>
              {openTab === 'Finance24' ? <Arrow /> : <Arrow active />}
            </button>
          </li>

           <li className="border-b border-opacity-10 border-black 2xl:pb-5 pb-4 mb-2 cursor-pointer">
            <button
              onClick={() => handleTabClick('Finance25')}
              className={`${
                openTab === 'Finance25' && 'text-yellow'
              } w-full text-left flex items-center justify-between`}
            >
              <h5 className="font-semibold ">2025-26</h5>
              {openTab === 'Finance25' ? <Arrow /> : <Arrow active />}
            </button>
          </li>

          {/* ######## ADD MORE TABS HERE ############ */}
        </ul>
      </div>

      {/* All the Panels rendered here*/}

      <div className="flex-1 p-4">

        {/* Meetings panel */}
        {openPanel === 'Finance22' && <Finance00 />}
        {openPanel === 'Finance23' && <Finance01 />}
        {openPanel === 'Finance24' && <Finance02 />}
        {openPanel === 'Finance25' && <Finance03 />}
      </div>
    </div>
  )
}

export default Sidebar

const Arrow = ({ active }: { active?: boolean }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="10"
      viewBox="0 0 17 10"
      className={`mt-2 ${
        !active ? '-rotate-90 fill-yellow' : 'fill-black'
      } transition-all`}
    >
      <path d="M9.88647 8.92749L16.5347 2.27922C16.6587 2.15525 16.7571 2.00807 16.8242 1.84609C16.8912 1.6841 16.9258 1.51049 16.9258 1.33517C16.9258 0.981078 16.7851 0.641491 16.5347 0.391112C16.4108 0.267137 16.2636 0.168794 16.1016 0.1017C15.9396 0.0346049 15.766 7.25056e-05 15.5907 7.2498e-05C15.2366 7.24825e-05 14.897 0.140733 14.6466 0.391112L8.94242 6.10862L3.2382 0.391112C3.11459 0.266485 2.96753 0.167567 2.8055 0.100062C2.64347 0.0325572 2.46968 -0.0021979 2.29415 -0.00219791C2.11862 -0.00219791 1.94482 0.0325572 1.78279 0.100062C1.62076 0.167567 1.4737 0.266485 1.35009 0.391111C1.22547 0.51472 1.12655 0.661781 1.05904 0.823812C0.991536 0.985842 0.956782 1.15964 0.956782 1.33517C0.956782 1.5107 0.991536 1.68449 1.05904 1.84652C1.12655 2.00855 1.22547 2.15561 1.35009 2.27922L7.99836 8.92749C8.12197 9.05212 8.26903 9.15104 8.43106 9.21854C8.59309 9.28605 8.76689 9.3208 8.94242 9.3208C9.11795 9.3208 9.29174 9.28605 9.45377 9.21854C9.6158 9.15104 9.76286 9.05212 9.88647 8.92749Z" />
    </svg>
  )
}
